import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as InstitutionFeatureState from './institution.state';

export const selectInstitutionsState =
  createFeatureSelector<InstitutionFeatureState.InstitutionState>(
    InstitutionFeatureState.institutionFeatureKey
  );

export const selectInstitutions = createSelector(
  selectInstitutionsState,
  InstitutionFeatureState.selectAll
);
export const selectInstitutionsLoading = createSelector(
  selectInstitutionsState,
  (state) => state.loading
);

/**
 * OC-2. The size of the whole matched set. Deliberately not derived from
 * selectInstitutions, whose length is now one page.
 */
export const selectInstitutionsTotalCount = createSelector(
  selectInstitutionsState,
  (state) => state.institutionsTotalCount
);

/** OC-2. Where the current page starts, and how big it is. */
export const selectInstitutionsPage = createSelector(
  selectInstitutionsState,
  (state) => ({
    offset: state.institutionsForOccupationOptions?.offset ?? 0,
    limit: state.institutionsForOccupationOptions?.limit ?? null
  })
);

export const selectInstitutionsForOccupationOptions = createSelector(
  selectInstitutionsState,
  (state) => state.institutionsForOccupationOptions
);

export const selectSelectedInstitutionId = createSelector(
  selectInstitutionsState,
  (state) => state.selectedInstitutionId
);

export const selectSelectedInstitutionDetails = createSelector(
  selectInstitutionsState,
  (state) => state.selectedInstitutionDetails
);

export const selectInstitutionsByProgram = createSelector(
  selectInstitutionsState,
  (state) => state.institutionsByProgram
);
